import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import api from '../../api/config';
import { PiNotebookFill, PiArrowLeftBold } from "react-icons/pi";
import { GiWhiteBook } from "react-icons/gi";
import { FiMail, FiPhone, FiMapPin, FiCalendar } from 'react-icons/fi';
import './detay.css';

const BasvuruDetay = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { applicantData, kaynakTab } = location.state || {};
  const [photoUrl, setPhotoUrl] = useState(applicantData?.photoUrl);

  const fetchPhoto = useCallback(async () => {
    if (!applicantData?.user_id) return;
    try {
      const response = await api.get(`/api/photo/${applicantData.user_id}`, { responseType: 'blob' });
      if (response.status === 200) {
        setPhotoUrl(URL.createObjectURL(response.data));
      }
    } catch (error) {
      console.error('Fotoğraf yükleme hatası:', error);
    }
  }, [applicantData?.user_id]);

  useEffect(() => {
    if (applicantData && !photoUrl) {
      fetchPhoto();
    }
  }, [applicantData, photoUrl, fetchPhoto]);

  if (!applicantData) {
    return (
      <div className="corp-dashboard text-center" style={{ padding: '3rem' }}>
        <div className="error-message">Başvuru bilgisi bulunamadı.</div>
        <button onClick={() => navigate('/admin', { state: { activeMenu: kaynakTab } })}>
          Geri Dön
        </button>      </div>
    );
  }

  const handleCVDownload = async () => {
    if (applicantData.cv && applicantData.cv.file_path) {
      try {
        const response = await api.get(`/api/cv/download/${applicantData.cv.id}`, { responseType: 'blob' });
        const url = window.URL.createObjectURL(response.data);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = applicantData.cv.original_filename || 'cv.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('CV indirme hatası:', error);
        alert('CV indirirken bir hata oluştu.');
      }
    } else {
      alert('Bu başvuru için yüklenmiş bir CV dosyası bulunmamaktadır.');
    }
  };

  const generatePDF = async () => {
    const doc = new jsPDF('p', 'pt', 'a4', true);

    const turkishToASCII = (text) => {
      if (!text) return '';
      const turkishChars = {
        'ç': 'c', 'Ç': 'C', 'ğ': 'g', 'Ğ': 'G', 'ı': 'i', 'İ': 'I',
        'ö': 'o', 'Ö': 'O', 'ş': 's', 'Ş': 'S', 'ü': 'u', 'Ü': 'U'
      };
      return text.replace(/[çÇğĞıİöÖşŞüÜ]/g, letter => turkishChars[letter] || letter);
    };

    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 40;
    let yPos = margin;

    doc.setFont("helvetica");

    if (photoUrl) {
      try {
        const imgWidth = 90;
        const imgHeight = 90;
        const imgX = pageWidth - margin - imgWidth;

        const img = new Image();
        img.src = photoUrl;
        await new Promise((resolve) => { img.onload = resolve; });

        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const base64Image = canvas.toDataURL('image/jpeg');

        doc.addImage(base64Image, 'JPEG', imgX, yPos, imgWidth, imgHeight);
      } catch (error) {
        console.error('Fotoğraf eklenirken hata:', error);
      }
    }

    doc.setFontSize(20);
    doc.setTextColor(15, 23, 42);
    const headerText = turkishToASCII(`${applicantData.ad} ${applicantData.soyad}`);
    doc.text(headerText, margin, yPos + 25);
    yPos += 55;

    doc.setFontSize(10);
    doc.setTextColor(100, 116, 139);
    const contactInfo = turkishToASCII(`E-posta: ${applicantData.email} | Tel: ${applicantData.cep_telefonu}`);
    doc.text(contactInfo, margin, yPos);
    yPos += 15;

    const addressText = turkishToASCII(`Adres: ${applicantData.ev_adresi || '-'}`);
    doc.text(addressText, margin, yPos);
    yPos += 35;

    doc.setFontSize(13);
    doc.setTextColor(209, 42, 44);
    doc.text(turkishToASCII('Kişisel Bilgiler'), margin, yPos);
    yPos += 8;

    const personalInfoData = [
      ['Dogum Tarihi', applicantData.dogum_tarihi ? new Date(applicantData.dogum_tarihi).toLocaleDateString() : '-'],
      ['Askerlik Durumu', turkishToASCII(applicantData.askerlik_durumu || '-')],
      ['Surucu Belgesi', turkishToASCII(applicantData.surucu_belgesi || '-')],
      ['Medeni Durum', turkishToASCII(applicantData.medeni_durum || '-')],
      ['Cinsiyet', turkishToASCII(applicantData.cinsiyet || '-')]
    ];

    doc.autoTable({
      startY: yPos,
      body: personalInfoData,
      theme: 'plain',
      styles: { font: "helvetica", fontSize: 9, cellPadding: 4 },
      columnStyles: { 0: { fontStyle: 'bold', cellWidth: 120 }, 1: { cellWidth: 280 } }
    });

    yPos = doc.lastAutoTable.finalY + 20;

    if (applicantData.egitim_bilgileri?.length > 0) {
      doc.setFontSize(13);
      doc.setTextColor(209, 42, 44);
      doc.text(turkishToASCII('Egitim Bilgileri'), margin, yPos);
      yPos += 8;

      const educationData = applicantData.egitim_bilgileri.map(edu => [
        turkishToASCII(edu.okul_adi),
        turkishToASCII(edu.bolum),
        `${new Date(edu.baslangic_tarihi).toLocaleDateString()} - ${new Date(edu.bitis_tarihi).toLocaleDateString()}`
      ]);

      doc.autoTable({
        startY: yPos,
        head: [['Okul', 'Bolum', 'Tarih']],
        body: educationData,
        theme: 'striped',
        headStyles: { fillColor: [209, 42, 44], font: "helvetica" },
        styles: { font: "helvetica", fontSize: 9, cellPadding: 4 }
      });
      yPos = doc.lastAutoTable.finalY + 20;
    }

    if (applicantData.is_deneyimleri?.length > 0) {
      doc.setFontSize(13);
      doc.setTextColor(209, 42, 44);
      doc.text(turkishToASCII('Is Deneyimleri'), margin, yPos);
      yPos += 8;

      const experienceData = applicantData.is_deneyimleri.map(exp => [
        turkishToASCII(exp.firma_adi),
        turkishToASCII(exp.pozisyon),
        `${new Date(exp.baslangic_tarihi).toLocaleDateString()} - ${new Date(exp.bitis_tarihi).toLocaleDateString()}`
      ]);

      doc.autoTable({
        startY: yPos,
        head: [['Firma', 'Pozisyon', 'Tarih']],
        body: experienceData,
        theme: 'striped',
        headStyles: { fillColor: [209, 42, 44], font: "helvetica" },
        styles: { font: "helvetica", fontSize: 9, cellPadding: 4 }
      });
      yPos = doc.lastAutoTable.finalY + 20;
    }

    doc.save(`${turkishToASCII(applicantData.ad)}_${turkishToASCII(applicantData.soyad)}_Detay.pdf`);
  };

  return (
    <div className="profile-detail-page">
      <div className="profile-detail-container">

        {/* İşlem Butonları */}
        <div className="profile-action-bar">
          <button className="btn-back-nav" onClick={() => navigate('/admin', { state: { activeMenu: kaynakTab } })}>
            <PiArrowLeftBold /> Geri Dön
          </button>
          <div className="right-buttons">
            <button className="btn-corp-action btn-red" onClick={generatePDF}>
              <PiNotebookFill /> Özeti PDF İndir
            </button>
            <button className="btn-corp-action btn-outline" onClick={handleCVDownload}>
              <GiWhiteBook /> Ekli CV Dosyasını İndir
            </button>
          </div>
        </div>

        {/* Kurumsal Profil Üst Kartı */}
        <div className="profile-hero-card">
          {photoUrl ? (
            <div className="profile-hero-avatar">
              <img src={photoUrl} alt={`${applicantData.ad} ${applicantData.soyad}`} />
            </div>
          ) : (
            <div className="profile-hero-avatar text-avatar">
              {applicantData.ad?.[0]}{applicantData.soyad?.[0]}
            </div>
          )}

          <div className="profile-hero-main">
            <h1>{applicantData.ad} {applicantData.soyad}</h1>
            <div className="profile-hero-meta">
              <span><FiMail /> {applicantData.email}</span>
              <span><FiPhone /> {applicantData.cep_telefonu}</span>
              {applicantData.ev_adresi && <span><FiMapPin /> {applicantData.ev_adresi}</span>}
            </div>
            <div className="profile-hero-badges">
              {applicantData.mezuniyet && <span className="p-badge bg-blue">{applicantData.mezuniyet}</span>}
              {applicantData.medeni_durum && <span className="p-badge bg-gray">{applicantData.medeni_durum}</span>}
              {applicantData.cinsiyet && <span className="p-badge bg-gray">{applicantData.cinsiyet}</span>}
            </div>
          </div>
        </div>

        {/* Detay Bilgileri İki Sütunlu Grid */}
        <div className="profile-detail-grid">

          {/* Sol Kolon: Temel ve Yan Bilgiler */}
          <div className="profile-left-column">
            <div className="corp-section-card">
              <h3>Kişisel Bilgiler</h3>
              <div className="profile-meta-list">
                <div className="meta-item">
                  <span className="label">Doğum Tarihi:</span>
                  <span className="value">
                    <FiCalendar style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                    {applicantData.dogum_tarihi ? new Date(applicantData.dogum_tarihi).toLocaleDateString('tr-TR') : '-'}
                  </span>
                </div>
                <div className="meta-item">
                  <span className="label">Askerlik Durumu:</span>
                  <span className="value">{applicantData.askerlik_durumu || '-'}</span>
                </div>
                <div className="meta-item">
                  <span className="label">Sürücü Belgesi:</span>
                  <span className="value">{applicantData.surucu_belgesi || '-'}</span>
                </div>
              </div>
            </div>

            <div className="corp-section-card">
              <h3>Yabancı Diller</h3>
              {applicantData.yabanci_diller?.length > 0 ? (
                <div className="pill-list">
                  {applicantData.yabanci_diller.map((lang, index) => (
                    <div key={index} className="pill-item">
                      <strong>{lang.dil_adi}</strong>
                      <span className="level">Seviye: {lang.seviye}/5</span>
                    </div>
                  ))}
                </div>
              ) : <p className="text-empty">Belirtilmedi</p>}
            </div>

            <div className="corp-section-card">
              <h3>İlgi Alanları</h3>
              {applicantData.ilgi_alanlari?.length > 0 ? (
                <div className="tags-flex">
                  {applicantData.ilgi_alanlari.map((interest, index) => (
                    <span key={index} className="tag-item">{interest.ilgi_alani}</span>
                  ))}
                </div>
              ) : <p className="text-empty">Belirtilmedi</p>}
            </div>
          </div>

          {/* Sağ Kolon: Kronolojik Deneyim ve Eğitim Yapıları */}
          <div className="profile-right-column">
            <div className="corp-section-card">
              <h3>İş Deneyimleri</h3>
              {applicantData.is_deneyimleri?.length > 0 ? (
                <div className="timeline-wrapper">
                  {applicantData.is_deneyimleri.map((exp, index) => (
                    <div key={index} className="timeline-node">
                      <div className="node-header">
                        <h4>{exp.pozisyon}</h4>
                        <span className="node-date">
                          {new Date(exp.baslangic_tarihi).toLocaleDateString('tr-TR')} -
                          {new Date(exp.bitis_tarihi).toLocaleDateString('tr-TR')}
                        </span>
                      </div>
                      <p className="node-sub">{exp.firma_adi}</p>
                    </div>
                  ))}
                </div>
              ) : <p className="text-empty">Kayıtlı iş deneyimi bulunmuyor.</p>}
            </div>

            <div className="corp-section-card">
              <h3>Eğitim Bilgileri</h3>
              {applicantData.egitim_bilgileri?.length > 0 ? (
                <div className="timeline-wrapper">
                  {applicantData.egitim_bilgileri.map((edu, index) => (
                    <div key={index} className="timeline-node blue-node">
                      <div className="node-header">
                        <h4>{edu.bolum}</h4>
                        <span className="node-date">
                          {new Date(edu.baslangic_tarihi).toLocaleDateString('tr-TR')} -
                          {new Date(edu.bitis_tarihi).toLocaleDateString('tr-TR')}
                        </span>
                      </div>
                      <p className="node-sub">{edu.okul_adi}</p>
                    </div>
                  ))}
                </div>
              ) : <p className="text-empty">Kayıtlı eğitim bilgisi bulunmuyor.</p>}
            </div>

            <div className="corp-section-card">
              <h3>Sertifikalar</h3>
              {applicantData.sertifikalar?.length > 0 ? (
                <div className="simple-list">
                  {applicantData.sertifikalar.map((cert, index) => (
                    <div key={index} className="simple-list-item">
                      <span>{cert.sertifika_adi}</span>
                      <small>{new Date(cert.alindi_tarihi).toLocaleDateString('tr-TR')}</small>
                    </div>
                  ))}
                </div>
              ) : <p className="text-empty">Belirtilmedi</p>}
            </div>

            <div className="corp-section-card">
              <h3>Referanslar</h3>
              {applicantData.referanslar?.length > 0 ? (
                <div className="simple-list">
                  {applicantData.referanslar.map((ref, index) => (
                    <div key={index} className="simple-list-item column-style">
                      <strong>{ref.referans_adi}</strong>
                      <span>{ref.referans_iletisim}</span>
                    </div>
                  ))}
                </div>
              ) : <p className="text-empty">Kayıtlı referans bulunmuyor.</p>}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default BasvuruDetay;